/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateHolidayCalendarInput = {
    id: string;
    name?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateHolidayCalendarMutationVariables = {
    input: UpdateHolidayCalendarInput;
};
export type updateHolidayCalendarMutationResponse = {
    readonly updateHolidayCalendar: {
        readonly holidayCalendar: {
            readonly name: string | null;
        } | null;
    } | null;
};
export type updateHolidayCalendarMutation = {
    readonly response: updateHolidayCalendarMutationResponse;
    readonly variables: updateHolidayCalendarMutationVariables;
};



/*
mutation updateHolidayCalendarMutation(
  $input: UpdateHolidayCalendarInput!
) {
  updateHolidayCalendar(input: $input) {
    holidayCalendar {
      name
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateHolidayCalendarInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateHolidayCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHolidayCalendarPayload",
        "kind": "LinkedField",
        "name": "updateHolidayCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendar",
            "kind": "LinkedField",
            "name": "holidayCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateHolidayCalendarMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateHolidayCalendarPayload",
        "kind": "LinkedField",
        "name": "updateHolidayCalendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "HolidayCalendar",
            "kind": "LinkedField",
            "name": "holidayCalendar",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateHolidayCalendarMutation",
    "operationKind": "mutation",
    "text": "mutation updateHolidayCalendarMutation(\n  $input: UpdateHolidayCalendarInput!\n) {\n  updateHolidayCalendar(input: $input) {\n    holidayCalendar {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '7a64258d77af3a9f4949a9cae99f9d84';
export default node;
